export const BACKEND_URL = "https://strapi.jkeppeler-dev.de";
//export const BACKEND_URL = "http://localhost:1337";
